// extracted by mini-css-extract-plugin
module.exports = {"title1":"ArticleTitle-module--title1--1WWl5","title2":"ArticleTitle-module--title2--ETOF9","title3":"ArticleTitle-module--title3--Ov_xp"};